import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { DadosService } from '../../db/dados.service';
import { Subscription } from 'rxjs';
import { ISplash } from '../../../../models/splash.model';
import { DivulgacaoFornecedor,IDivulgacaoFornecedor } from '../../../../models/divulgacao.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-splash',
  templateUrl: './splash.component.html',
  styleUrls: ['./splash.component.scss']
})
export class SplashComponent implements OnInit, OnDestroy {
  imgCorrente: string = null;
  openEvent:Subscription;
  splash:ISplash={};
  FSplash:ISplash[]=[];
  FDivulgacao : DivulgacaoFornecedor;

  constructor(private dados: DadosService,
   private router:Router) { 
   this.FDivulgacao = new DivulgacaoFornecedor(this.dados.connection);
  }

  ngOnInit() {
    this.openEvent = this.dados.splashClass.changedEvent.subscribe(
       d => {
         console.log(d);
         this.FSplash = d;
         this.localSplash();
       }
     )
    //this.dados.splashClass.snapshot(
    //  r=> r.where("inativo",'==',false)
    //);
    this.dados.splashClass.emit();
   }

  ngOnDestroy(){
    this.openEvent.unsubscribe();
  }

  get localidadeNome(){
    return this.dados.localidadeNome;
  }
  set localidadeNome(x){
     this.dados.localidadeNome = x;
  }

  get localidades(){
    return this.dados.localidades;
  }

  localSplash() {
    if (this.imgCorrente == null) {
      let mx = this.FSplash.length,
        x = Math.floor((Math.random() * mx));
        if (x>=this.FSplash.length)
         x = this.FSplash.length-1;
      if (x<0) x= 0;     
      
      if (x<this.FSplash.length) {
        this.splash = this.FSplash[x];  
        this.imgCorrente = this.splash.img;
        this.FDivulgacao.addDivulgacao(this.splash.anunciante,'splash',1);
      } else {
        this.splash = {};
      }
    }
    return this.imgCorrente;
  }

  entrar(){
    this.dados.regAnalytics(0,'acessos','acessos',1);
    this.router.navigate(['/menu']);
  }
}
